/*=========================================================================================
  File Name: ticketGetters.js
  Description: Ticket Getters
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

export default {
    status: state => state.status,
    notification: state => state.notification
};